import { Inline, Text, vars } from '@etg/wings';
import { useRevolut, useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { generateDurationText } from '../../utils/calendarDateUtils';

interface CalendarFooterProps {
  departureDate?: Date | string | null;
  returnDate?: Date | string | null;
}

const calendarFooterTextStyles = css`
  color: ${vars.colors.text.primary};
`;

const calendarFooterF1TextStyles = css`
  color: ${vars.colors.text.secondary};
  font-size: 1rem;
`;

const CalendarFooter = ({ departureDate, returnDate }: CalendarFooterProps) => {
  const { t } = useTranslation();
  const { isRevolut } = useRevolut();
  return (
    <Inline align="center">
      <Text
        as="p"
        className={cx(calendarFooterTextStyles, {
          [calendarFooterF1TextStyles]: isRevolut,
        })}
      >
        {generateDurationText(
          departureDate,
          returnDate,
          t('Searchform.Calendar.DaysLeft.Singular'),
          t('Searchform.Calendar.DaysLeft.Plural'),
        )}
      </Text>
    </Inline>
  );
};

export default CalendarFooter;
